<template>
	<div id="reg" class="col-12 formulate-form">
		<div v-if="block.block_title" class="row panel_header">
			<h2 class="col-12 mb-4">
				{{ block.block_title }}
			</h2>
		</div>
		<div v-if="block.subtitle" class="col-12">
			<p>{{ block.subtitle }}</p>
		</div>

		<div v-if="okSuccessMessage">
			<div>
				<div>
					<h4 class="title title-lg mb-4">
						{{ okSuccessMessage.title }}
					</h4>
					<div v-html="okSuccessMessage.value" />
				</div>
				<div
					v-if="okSuccessMessage.is_button_enabled == 1"
					class="p-4 w-lg-50"
				>
					<a :href="okSuccessMessage.button_link">
						<b-button variant="primary">
							{{ okSuccessMessage.button_text }}
						</b-button>
					</a>
				</div>
			</div>

			<FormulateInput
				type="button"
				@click="onClickAgainSubmit"
			>
				Отправить форму повторно
			</FormulateInput>
		</div>
		<div v-else>
			<div
				v-if="!isFormClosed"
				class="row"
			>
				<div class="col-12 col-lg data-block">
					<FormulateForm
						v-if="autocompleted"
						v-model="formValues"
						:schema="schema"
						class="row"
						@submit="submit"
						@onChangeSwitchMiddleName="onChangeSwitchMiddleName"
						@setCompanyInfo="setCompanyInfo"
						@validatePhone="validatePhone"
					>
						<div
							class="col-12 mb-4 order-0"
						>
							<products-component
								v-model="products"
								:block="block"
							/>
						</div>

						<div
							v-if="!schema.length"
							class="col-12 mb-4"
						>
							<div class="border d-flex align-items-center justify-content-center h-100 p-4">
								<kind />
								<div class="title ml-3 text-left mb-0">
									Все необходимые данные заполнены, можно перейти к оплате
								</div>
							</div>
						</div>


						<div v-if="!block.hide_promo_code_field" class="col-12 order-2 mb-4 mb-lg-0">
							<div class="mb-4">
								<label class="mb-2" for="promocode">Промокод</label>
								<div
									class="formulate-promocode"
									:class="isActivatePromocode ? 'formulate-promocode--active' : ''"
								>
									<FormulateInput
										v-if="!isActivatePromocode"
										id="promocode"
										v-model.trim="promocode"
										type="text"
										name="promo"
										placeholder="Промокод"
										class="px-0 mb-0 mr-2 promocode-input col"
									/>
									<div v-else class="formulate-promocode--active__text px-0 col">
										Промокод применен
									</div>
									<div
										v-if="promocode.length > 0 && !isActivatePromocode"
										@click="checkPromocodeLanding"
									>
										<icon-arrow-right
											class="arrow-right--black"
										/>
									</div>
									<div
										v-else-if="isActivatePromocode"
										class="close"
										@click="resetPromocode"
									/>
								</div>
								<div
									class="formulate-promocode__error"
								>
									{{ promocodeMessage }}
								</div>
							</div>
						</div>

						<points-window
							v-if="isBlockContainsLoyaltyEarnProduct || isBlockContainsLoyaltyChargeProduct"
							:fetched-data="fetchedData"
							:block="block"
							:card-background="cardBackground"
							:final-price="finalPrice"
							:loyalty-data="loyaltyData"
							:loyalty-profile="loyaltyProfile"
							:original-price="originalPrice"
							:is-promo-code-used="isActivatePromocode"
							:products="products"
							:show-default-block="true"
							class="charge-points col-12 d-block d-lg-none mb-3 order-3"
							@setLoyaltyData="setLoyaltyData"
						/>
						<div v-else class="col-12 mb-3 order-3">
							<div class="amount_block mt-3 mb-3">
								<div
									class="d-flex justify-content-between align-items-center"
								>
									<span class="title">Итого</span>
									<span v-if="discount || isActivatePromocode" class="title">
										{{ createMaskAmount(finalPrice) }} руб
									</span>
									<span v-else class="title">
										{{ createMaskAmount(originalPrice) }} руб
									</span>
								</div>
								<div
									v-if="(discountPrice > 0 && discount) || isActivatePromocode"
									class="d-flex justify-content-end align-items-center"
								>
									<span class="original_amount">
										{{ createMaskAmount(originalPrice) }} руб
									</span>
								</div>
							</div>
						</div>

						<div class="mb-4 col-12 order-5">
							<FormulateInput
								v-if="showPersonalData"
								class="mb-3 small"
								type="checkbox"
								validation="required"
								name="personalData"
								:validation-messages="{
									required: `${$t('agreementRequired')}`
								}"
								data-action="personalData"
							>
								<template #label="{ id }">
									<label :for="id" class="ml-2">
										Отправляя форму, я даю

										<a
											:href="`https://www.skolkovo.ru/static/personaldata_rus.html`"
											target="_blank"
										>
											согласие на обработку моих персональных данных
										</a>
									</label>
								</template>
							</FormulateInput>

							<PublicOfferAgreementInput
								v-for="(item, index) in block.agreements"
								:key="index"
								:href="item"
							/>

							<advertising-mailings-input />

							<loyalty-registration-input />

							<b2b-alumni-input v-if="block.showb2bAlumniInput" />

						</div>
						<FormulateInput
							type="submit"
							class="col-12 mb-3 mb-sm-0 order-6"
							:disabled="isLoadingSubmit"
						>
							<b-spinner
								v-if="isLoadingSubmit"
								style="margin-right: 15px; width: 1.3em; height: 1.3em;"
							/>
							{{ isLoadingSubmit ? `${$t('sending')}...` : $t('registration') }}
						</FormulateInput>
						<CookieError v-if="isErrorCookie" />
					</FormulateForm>
				</div>
				<points-window
					v-if="isBlockContainsLoyaltyEarnProduct || isBlockContainsLoyaltyChargeProduct"
					:fetched-data="fetchedData"
					:block="block"
					:card-background="cardBackground"
					:final-price="finalPrice"
					:loyalty-data="loyaltyData"
					:loyalty-profile="loyaltyProfile"
					:original-price="originalPrice"
					:is-promo-code-used="isActivatePromocode"
					:products="products"
					:show-default-block="true"
					class="col-12 col-lg-5 pl-lg-5 d-none d-lg-block"
					@setLoyaltyData="setLoyaltyData"
				/>
			</div>
			<div
				v-else
				class="theme-inverse row justify-content-center py-5"
			>
				<div class="title">
					Регистрация закрыта
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapActions } from 'vuex';
import formulateFormScenario from '~/mixins/formulateFormScenario';
import Kind from '~/static/svg/kind.vue';
import IconArrowRight from '~/static/svg/icon-arrow-right.vue';
import ProductsComponent from '~/components/panels/formulate/products/ProductsComponent.vue';
import '~/utils/vue-formulate';
import LoyaltyRegistrationInput from '~/components/panels/formulate/products/components/LoyaltyRegistrationInput.vue';
import b2bAlumniInput from '~/components/panels/formulate/products/components/b2bAlumniInput.vue';
import AdvertisingMailingsInput from '~/components/panels/formulate/products/components/AdvertisingMailingsInput.vue';
import PublicOfferAgreementInput from '~/components/panels/formulate/products/components/PublicOfferAgreementInput.vue';
import CookieError from '~/components/panels/formulate/products/components/CookieError.vue';
import PointsWindow from '~/components/formulate/loyalty/PointsWindow.vue';
import { LOYALTY_LEVELS } from '~/utils/dictionaries';
import moment from '@/utils/moment';

export default {
	name: 'LandingProgramPaymentRedirectOkSuccessScenario',
	components: {
		PointsWindow,
		LoyaltyRegistrationInput,
		AdvertisingMailingsInput,
		PublicOfferAgreementInput,
		Kind,
		IconArrowRight,
		ProductsComponent,
		CookieError,
		b2bAlumniInput,
	},
	mixins: [formulateFormScenario],
	data() {
		return {
			levels: LOYALTY_LEVELS,
			checked: true,
			delayed_payment: false,
			can_return_vat_selected: false,
			loyaltyData: null,
			loyaltyProfile: {},
			cardBackground: null,
		};
	},
	computed: {
		finalPrice() {
			if (!this.priceWithPromocode) {
				if (this.discountPrice > 0 && this.discount) return this.discountPrice;
				return this.can_return_vat_selected
					? this.priceWithoutVat
					: this.amount;
			}

			return this.priceWithPromocode;
		},
		originalPrice() {
			return this.can_return_vat_selected
				? this.priceWithoutVat
				: this.amount;
		},
		priceWithoutVat() {
			return this.allProductsByType.reduce(
				(sum, product) => parseFloat(sum) + parseFloat(product?.price_without_vat ?? 0),
				0,
			);
		},
		savedVat() {
			return this.$store.state.cart.vat;
		},
	},
	watch: {
		savedVat: {
			handler() {
				this.can_return_vat_selected = this.$store.state.cart.vat;
			},
		},
		selectedProducts: {
			handler() {
				if (this.priceWithPromocode) {
					this.checkDate();
					this.checkPromocodeLanding();
				}
			},
			deep: true,
		},
	},
	async mounted() {
		await this.getLoyaltyProfile();
	},
	methods: {
		...mapActions({
			removeProduct: 'cart/removeProduct',
			returnVat: 'cart/returnVat',
		}),
		setLoyaltyData(val) {
			this.loyaltyData = val;
		},
		async getLoyaltyProfile() {
			const { data } = await this.$api.getLoyaltyProfile();

			if (data) {
				this.loyaltyProfile = data;
				const [currentLevel] = this.levels.filter((el) => el.id === this.loyaltyProfile.level.id);
				this.cardBackground = currentLevel.color;
			}
		},
		checkPromocodeLanding() {
			this.checkPromocode(this.allProductsByType.map((product) => {
				let price = 0;
				if (this.discountPrice > 0 && this.discount) {
					price = this.discountPrice;
				} else {
					price = this.can_return_vat_selected
						? product.price_without_vat
						: product.price;
				}
				return {
					id: product.id,
					quantity: product.quantity,
					price,
				};
			}));
		},
		getData() {
			this.formValues.is_delayed_payment = +this.delayed_payment;

			if (!this.agreements.marketing_emails) {
				this.agreements.marketing_emails = !!this.formValues.advertisingMailingsAgreement;
			}
			if (!this.agreements.personal_data) {
				this.agreements.personal_data = !!this.formValues.personalData;
			}
			this.setAgreementFields();

			const userData = {
				sklTargetAction: this.block.form_scenario_action_label,
				sklBirthDate: this.formValues.birthday ? moment(this.formValues.birthday).format('DD.MM.YYYY') : '',
				advertisingMailingsAgreement: !!this.agreements.marketing_emails,
				sklAgreeSubscribeLookup: this.agreements.marketing_emails ? 'да' : 'нет',
				...this.formValues,
				...this.getAnalyticsData(),
				...{ can_return_vat_selected: +this.can_return_vat_selected },
			};

			const data = {
				products: this.selectedProducts ?? null,
				user_data: userData,
				entity_name: this.fetchedData.entity_name,
				entity_id: this.fetchedData.id,
				loyalty_data: this.loyaltyData,
			};

			if (this.isActivatePromocode) {
				data.user_data.promo = this.promocode;
			}

			return data;
		},
		selectDoc(item) {
			this.returnVat(item);
			if (this.priceWithPromocode) {
				this.checkPromocodeLanding();
			}
		},
	},
};
</script>

<style lang="scss" scoped>
@import "assets/styles/sk_variables";
// For use bootstrap vars and mixins inside
@import "assets/styles/bootstrap/scss/functions";
@import "assets/styles/bootstrap/scss/variables";
@import "assets/styles/bootstrap/scss/mixins";

// .data-block {
// 	@include media-breakpoint-up(lg) {
// 		border-right: 1px solid rgba(0, 0, 0, 0.125);
// 	}
// }

.charge-points {
	padding: 0 0.75rem 0;
}

.title {
	margin-bottom: 0;
}

.close {
	cursor: pointer;
	opacity: 1;
}

.close::before {
	content: '\e915';
	font-size: 1rem;
}

.arrow-right {
	&--black {
		fill: black;
		padding: 0;
		cursor: pointer;
	}
}
</style>
